import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Heading,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import http from "../../../core/http";
import { Card } from "../../auth/components/Login/Card";
import ReadingOrderForm from "../components/PartnerReadingOrderForm";

function PartnerReadingOrderNew() {
  const navigate = useNavigate();
  const toast = useToast();

  // Handle form submit
  async function handleSubmit(values) {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("franchise", values.franchise);
    formData.append("order", values.order);
    formData.append("published", 0);
    formData.append("from_year", values.fromYear);
    formData.append("to_year", values.toYear);
    formData.append("is_ongoing", values.isOngoing);
    formData.append("thumbnail", values.thumbnail);

    try {
      await http.post("/v1/partner/reading-orders", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast({
        title: "Information saved.",
        description: "You can now edit your reading order.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      navigate(`/partnership/reading-orders/all`);

      // handle success
    } catch (error) {
      console.error(error);
      // handle error
      toast({
        title: "Error occured",
        description: error.message,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    }
  }

  return (
    <Box
      bg={useColorModeValue("gray.50", "inherit")}
      minH="100vh"
      py="12"
      px={{ base: "4", lg: "8" }}
    >
      <Box maxW="xl" mx="auto">
        <Breadcrumb mb="3">
          <BreadcrumbItem>
            <BreadcrumbLink as={Link} to="/partnership/reading-orders/all">
              Reading Orders
            </BreadcrumbLink>
          </BreadcrumbItem>

          <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink>New reading order</BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>

        <Card>
          <Heading as="h2" mb="6">
            New reading order
          </Heading>
          <ReadingOrderForm handleSubmit={handleSubmit} />
        </Card>
      </Box>
    </Box>
  );
}

export default PartnerReadingOrderNew;
